;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputDropdownInline', inputDropdownInline)

  /* @ngInject */
  function inputDropdownInline ($compile) {
    return {
      restrict: 'E',
      scope: {
        html: '<'
      },
      replace: true,
      link: function (scope, element) {
        const compiledHtml = $compile(scope.html)(scope)
        $(element).append(compiledHtml)
      }
    }
  }
})()
